import { render, staticRenderFns } from "./gr.vue?vue&type=template&id=52f4cefa&scoped=true"
import script from "./gr.vue?vue&type=script&lang=js"
export * from "./gr.vue?vue&type=script&lang=js"
import style0 from "./gr.vue?vue&type=style&index=0&id=52f4cefa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f4cefa",
  null
  
)

export default component.exports